import React from 'react';
import Card from '@material-ui/core/Card';
import LinearProgress from '@material-ui/core/LinearProgress';

import { Div, useStyles } from './styles';
import './styles.css';

const Map = ({ loading }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Card className={classes.card}>
        <Div className='mapa_style' id='map' /> {loading && <LinearProgress />}
      </Card>
    </div>
  );
}

export default Map;
